<div class="manage-my-repair-loader">
  <div class="heading">
    <div class="page-title light shimmer"></div>
    <div class="page-subtitle light shimmer"></div>
  </div>
  <div class="section-wrapper">
    <div class="section">
      <div class="title dark shimmer"></div>
      <div class="content dark shimmer"></div>
    </div>

    <div *ngFor="let _ of sections" class="section">
      <div class="title dark shimmer"></div>

      <div class="content-wrapper">
        <div class="content dark shimmer"></div>
        <div class="content dark shimmer"></div>
        <div class="content dark shimmer"></div>
      </div>
    </div>
  </div>
</div>
